/* eslint-disable max-classes-per-file */
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import TaskBox from './TaskBox';
import styles from './TaskSVG.module.css';

export default class TaskSVG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderAnimation: false,
      translate: 0,
      boxes: []
    };
  }

  componentDidMount() {
    this.setState({ boxes: this.createDefaultBoxes() });
  }

  createDefaultBoxes = () => {
    const { annotation, annotationList } = this.props;
    const boxes = [];
    for (let i = 0; i <= 4; i += 1) {
      const newBox = {
        id: i,
        delay: i <= 1 ? 0 : (i - 1) * 2000,
        annotation:
          (annotationList || []).length > 1
            ? annotationList[Math.floor(Math.random() * annotationList.length - 1) + 1]
            : annotation
      };
      boxes.push(newBox);
    }
    return boxes;
  };

  addNewBox = id => {
    const { boxes, translate } = this.state;
    const { annotation, annotationList } = this.props;
    const newBox = {
      id: id + 3,
      delay: 6000,
      annotation:
        (annotationList || []).length > 1
          ? annotationList[Math.floor(Math.random() * annotationList.length - 1) + 1]
          : annotation
    };
    boxes.push(newBox);
    let newTranslate = translate;
    newTranslate += 64;
    this.setState({ boxes, translate: newTranslate });
  };

  handleVisibilityChange = isVisible => {
    const { renderAnimation } = this.state;
    if (isVisible && !renderAnimation) {
      this.startAnimation();
    }
  };

  startAnimation = () => {
    this.setState(
      {
        translate: 0,
        boxes: this.createDefaultBoxes()
      },
      () => this.setState({ renderAnimation: true })
    );
  };

  render() {
    const { boxes, translate, renderAnimation } = this.state;

    return (
      <VisibilitySensor onChange={this.handleVisibilityChange} scrollCheck partialVisibility>
        <div className={`${styles.viewport} overflow-hidden rounded-lg shadow-2xl relative`}>
          {renderAnimation && (
            <div
              className={`${styles.content} content p-4`}
              style={{ transform: `translate3d(0, -${translate}px, 0)` }}
            >
              {boxes.map(e => (
                <TaskBox
                  key={`statusbox-${e.id}`}
                  id={e.id}
                  delay={e.delay}
                  addNewBox={this.addNewBox}
                  limit={50}
                  annotation={e.annotation}
                />
              ))}
            </div>
          )}
          <div className="absolute top-0 w-full h-24 bg-gradient-to-b from-black" />
          <div className="absolute bottom-0 w-full h-24 bg-gradient-to-t from-black" />
        </div>
      </VisibilitySensor>
    );
  }
}
